export default {
    addEvent: 'Add additional event',
    removeEvent: 'Remove event',
    chapel: 'Chapel *',
    camera: 'Camera *',
    eventType: 'Event Type *',
    specialNote: 'Special Requests / Internal Note To Videographer',
};
